import React, { Component } from 'react';
import { Route, Router, Switch, Redirect } from 'react-router-dom';
import './App.scss';
import '../node_modules/ol/ol.css'
import Morpheus from './view/morpheus';
import { LandingView } from './view/landing'
import { LoginView } from './view/loginview';
import { historyMP } from './helper/history';
import { PrivateRoute, LoginRoute } from '../src/helper/private.route';
import { globalUrlPrefix } from './utils/const'
import "./asset/style/morpheus.css"
import 'antd/dist/antd.css';
import Scan from './view/scan';

class App extends Component {
  render() {
    return (
      <Router history={historyMP}>
      <div className="App">
          <Switch>
            <LoginRoute exact path="/login" component={LoginView} />
            <PrivateRoute path={"/" + globalUrlPrefix + "/viewer/:id/"} component={Scan} />
            <PrivateRoute path={"/" + globalUrlPrefix} component={Morpheus}/>
            <Route path={"/dashboard"} render={() => <Redirect to={"/" + globalUrlPrefix + "/dashboard" }/>} />
            <Route path={"/viewer/:id/"} render={(props) => <Redirect to={"/" + globalUrlPrefix + "/viewer/" + props.match.params.id }/>} />
            <Route path={"/"} render={() => <Redirect to={"/login" }/>} />
          </Switch>
      </div>
      </Router>
    );
  }
}

export default App;